import React from 'react';
import { SideBar } from './sidebar';
import swal from 'sweetalert';
import { getMask, updateMask, deleteMask } from '../../models/masks';
import i18n from '../../i18n';
import { HomeBanner } from '../home/homeBanner';
export class EditMask extends React.Component {
  constructor(props) {
    super(props);
    let path = window.location.pathname;
    let maskId = path.substring(path.lastIndexOf('/') + 1, path.length);
    this.state = {
      input: {},
      maskId: maskId,
      errors: {},
      masks: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.loadMask();
  }

  async loadMask() {
    const response = await getMask(this.state.maskId);
    let mask = response.data;
    this.setState({ input: mask });
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    console.log(event.target.name + ', ' + event.target.value);
    this.setState({ input });
  }
  handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await updateMask(this.state.input, this.state.maskId);
      if (response && response.data && response.data.id) {
        swal(i18n.t('success'), response.message, 'success', {
          buttons: false,
          timer: 2000,
        }).catch((response) => {
          swal('Failed', response.message, 'error');
        });
      } else {
        let error_message = response.message;
        let resObject = response.data;
        for (const key in resObject) {
          if (Object.hasOwnProperty.call(resObject, key)) {
            let element = resObject[key];
            error_message += '\n' + element;
          }
        }
        swal('Failed', error_message, 'error');
      }
    } catch (err) {
      console.log(err);
    }
  };

  deleteRow(id) {
    const response = deleteMask(this.state.maskId);
    console.log(response);
    swal(i18n.t('success'), 'Item deleted', 'success', {
      buttons: false,
      timer: 2000,
    })
      .then((response) => {
        this.loadAllMasks();
      })
      .catch((response) => {
        swal('Failed', 'Something went wrong', 'error');
      });
  }

  render() {
    return (
      <React.Fragment>
        <HomeBanner callbackForSupport={this.props.callbackForSupport} />

        <section className="sptb mt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                <SideBar />
              </div>
              <div className="col-xl-9 col-lg-12 col-md-12">
                <form
                  id="UpdateProfile"
                  className="card mb-0"
                  autoComplete="off"
                  onSubmit={this.handleSubmit}
                >
                  <div className="card-header">
                    <h3 className="card-title">Update Mask</h3>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <label className="form-label">Mask Name</label>
                          <input
                            type="text"
                            name="mask_name"
                            className="form-control"
                            placeholder="Mask Name"
                            value={this.state.input.mask_name}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <label className="form-label">Class</label>
                          <select
                            className="form-control"
                            data-placeholder="Select Class"
                            name="class"
                            value={this.state.input.class}
                            onChange={this.handleChange}
                          >
                            <option value="">--Class--</option>
                            <option value="D">Diamond</option>
                            <option value="G">Gold</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <label className="form-label">Start Amount</label>
                          <input
                            type="text"
                            name="start_amount"
                            className="form-control"
                            placeholder="Amount"
                            value={this.state.input.start_amount}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div className="form-group">
                          <label className="form-label">Bid Increment</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Amount"
                            name="bid_increment"
                            value={this.state.input.bid_increment}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <div className="form-group">
                          <label className="form-label">&nbsp;</label>
                          <button type="submit" className="btn btn-primary">
                            Update Mask
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
